module.exports = __webpack_public_path__ + "static/media/insurance.bb702eec.png";